import axios from '@/lib/AxApi';

export default {
  getProtetics(params, cb)
  {
    axios.get('/rest/Protetics/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  saveProtetic(params, cb)
  {
    if(typeof params.id != 'undefined' && params.id != '')
    {
      axios.post('/rest/Protetics/updateRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
    else
    {
      axios.post('/rest/Protetics/insertRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
  },
  deleteProtetic(params, cb)
  {
    axios.post('/rest/Protetics/deleteRow', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  resetProtetics(params, cb)
  {
    axios.post('/rest/Protetics/resetProtetics', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/protetics.js